import {
  CheckboxWithLabel,
  CountrySelectorForHeader,
  InputWithLabel,
  SelectWithLabel
} from '@adotel/components'
import {
  ButtonBase,
  IconButton,
  MenuItem,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import DeleteIcon from '@material-ui/icons/Delete'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import React, { useState } from 'react'

import SectionTitle from '../../components/SectionTitle'
import { CountryType, countries } from '../../helpers/countriesList'
import { entityCodeRegex } from '../../helpers/regex'
import { getTranslate, lang } from '../../localization'
import { ProviderSubmit } from '../../types/accommodationProviderSubmit'
import { AddOnType } from '../../types/rateplan'
import useStyles from './Styles/ProviderAddons.style'

interface ProviderAddonsProps {
  selectedProviderSubmit: ProviderSubmit[]
  setSelectedProviderSubmit: React.Dispatch<
    React.SetStateAction<ProviderSubmit[]>
  >
  selectedProviderSubmitIndex: number
  isProviderExist: boolean
}

export default function ProviderAddons({
  selectedProviderSubmit,
  setSelectedProviderSubmit,
  selectedProviderSubmitIndex,
  isProviderExist
}: ProviderAddonsProps) {
  const classes = useStyles()
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
  const fixedAddonCount = 2 //addonIndex - 1
  const [clickOnProviderAddons, setClickOnProviderAddons] = useState(false)
  const [selectedCountryForName, setselectedCountryForName] =
    useState<CountryType>(countries[0])
  const AddOnTypeOptions: AddOnType[] = ['AddBed', 'Cot', 'Breakfast', 'Custom']

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <SectionTitle title="Addons" marginBottom />
        <IconButton
          className={classes.iconButton}
          onClick={() => {
            setClickOnProviderAddons(!clickOnProviderAddons)
          }}>
          {clickOnProviderAddons ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </div>
      {clickOnProviderAddons && (
        <>
          {selectedProviderSubmit[selectedProviderSubmitIndex].addOns.map(
            (item, addOnIndex) => (
              <div key={addOnIndex} className={classes.fieldsContainerAddon}>
                <SelectWithLabel
                  disabled={true}
                  label={getTranslate('Type')}
                  placeholder={getTranslate('Select Type')}
                  value={item.type}
                  onChange={(event) => {
                    setSelectedProviderSubmit([
                      ...selectedProviderSubmit.slice(
                        0,
                        selectedProviderSubmitIndex
                      ),
                      {
                        ...selectedProviderSubmit[selectedProviderSubmitIndex],
                        addOns: [
                          ...selectedProviderSubmit[
                            selectedProviderSubmitIndex
                          ].addOns.slice(0, addOnIndex),
                          {
                            ...selectedProviderSubmit[
                              selectedProviderSubmitIndex
                            ].addOns[addOnIndex],
                            type: event.target.value as AddOnType
                          },
                          ...selectedProviderSubmit[
                            selectedProviderSubmitIndex
                          ].addOns.slice(addOnIndex + 1)
                        ]
                      },
                      ...selectedProviderSubmit.slice(
                        selectedProviderSubmitIndex + 1
                      )
                    ])
                  }}
                  size="small">
                  {AddOnTypeOptions.map((ad) => (
                    <MenuItem key={ad} value={ad}>
                      {getTranslate(ad)}
                    </MenuItem>
                  ))}
                </SelectWithLabel>
                <InputWithLabel
                  disabled={item.type !== 'Custom'}
                  label={getTranslate('Name')}
                  placeholder={getTranslate('Enter the name')}
                  autoComplete="off"
                  inputSize="small"
                  value={item.name}
                  onChange={(event) => {
                    setSelectedProviderSubmit([
                      ...selectedProviderSubmit.slice(
                        0,
                        selectedProviderSubmitIndex
                      ),
                      {
                        ...selectedProviderSubmit[selectedProviderSubmitIndex],
                        addOns: [
                          ...selectedProviderSubmit[
                            selectedProviderSubmitIndex
                          ].addOns.slice(0, addOnIndex),
                          {
                            ...selectedProviderSubmit[
                              selectedProviderSubmitIndex
                            ].addOns[addOnIndex],
                            name: event.currentTarget.value
                          },
                          ...selectedProviderSubmit[
                            selectedProviderSubmitIndex
                          ].addOns.slice(addOnIndex + 1)
                        ]
                      },
                      ...selectedProviderSubmit.slice(
                        selectedProviderSubmitIndex + 1
                      )
                    ])
                  }}
                />
                <InputWithLabel
                  className={classes.fontFamilyInput}
                  disabled={item.type !== 'Custom'}
                  label={`${
                    lang === 'en' ? selectedCountryForName.language : ''
                  } ${getTranslate('Name')} ${
                    lang === 'fa' && selectedCountryForName.code === 'IR'
                      ? selectedCountryForName.nativeLanguage
                      : lang === 'fa'
                      ? selectedCountryForName.language
                      : ''
                  }`}
                  placeholder={
                    lang === 'fa' && selectedCountryForName.code === 'IR'
                      ? `${getTranslate('Enter the name in')} ${
                          selectedCountryForName.nativeLanguage
                        }`
                      : `${getTranslate('Enter the Persian name in')} ${
                          selectedCountryForName.language
                        }`
                  }
                  value={item.nameTranslatedList[0].value}
                  onChange={(event) => {
                    setSelectedProviderSubmit([
                      ...selectedProviderSubmit.slice(
                        0,
                        selectedProviderSubmitIndex
                      ),
                      {
                        ...selectedProviderSubmit[selectedProviderSubmitIndex],
                        addOns: [
                          ...selectedProviderSubmit[
                            selectedProviderSubmitIndex
                          ].addOns.slice(0, addOnIndex),
                          {
                            ...selectedProviderSubmit[
                              selectedProviderSubmitIndex
                            ].addOns[addOnIndex],
                            nameTranslatedList: [
                              {
                                value: event.currentTarget.value,
                                label: item.nameTranslatedList[0].label,
                                nativeLabel:
                                  item.nameTranslatedList[0].nativeLabel
                              }
                            ]
                          },
                          ...selectedProviderSubmit[
                            selectedProviderSubmitIndex
                          ].addOns.slice(addOnIndex + 1)
                        ]
                      },
                      ...selectedProviderSubmit.slice(
                        selectedProviderSubmitIndex + 1
                      )
                    ])
                  }}
                  autoComplete="off"
                  inputSize="small"
                  rightHeader={
                    <CountrySelectorForHeader
                      selectedCountry={selectedCountryForName}
                      onChange={(v: CountryType) => {
                        const translatedName = {
                          label: v.label,
                          nativeLabel: v.nativeLanguage,
                          value: ''
                        }
                        const tempTranslatedArr = [
                          ...item.nameTranslatedList,
                          translatedName
                        ]
                        setSelectedProviderSubmit([
                          ...selectedProviderSubmit.slice(
                            0,
                            selectedProviderSubmitIndex
                          ),
                          {
                            ...selectedProviderSubmit[
                              selectedProviderSubmitIndex
                            ],
                            addOns: [
                              ...selectedProviderSubmit[
                                selectedProviderSubmitIndex
                              ].addOns.slice(0, addOnIndex),
                              {
                                ...selectedProviderSubmit[
                                  selectedProviderSubmitIndex
                                ].addOns[addOnIndex],
                                nameTranslatedList: [...tempTranslatedArr]
                              },
                              ...selectedProviderSubmit[
                                selectedProviderSubmitIndex
                              ].addOns.slice(addOnIndex + 1)
                            ]
                          },
                          ...selectedProviderSubmit.slice(
                            selectedProviderSubmitIndex + 1
                          )
                        ])
                        setselectedCountryForName(v)
                      }}
                    />
                  }
                />
                <InputWithLabel
                  className={
                    isProviderExist &&
                    !selectedProviderSubmit[selectedProviderSubmitIndex].addOns[
                      addOnIndex
                    ].notDisabled
                      ? classes.codeInputDisabled
                      : ' '
                  }
                  label={getTranslate('Code')}
                  disabled={
                    item.type !== 'Custom' ||
                    (isProviderExist &&
                      !selectedProviderSubmit[selectedProviderSubmitIndex]
                        .addOns[addOnIndex].notDisabled)
                  }
                  placeholder={getTranslate('Enter the Code')}
                  autoComplete="off"
                  name="basicDetails.code"
                  id="basicDetails.code"
                  inputSize="small"
                  value={item.code}
                  onChange={(event) => {
                    const rawInput = event.currentTarget.value
                    const inputValue = rawInput.replace(/\s+/g, '') // remove all whitespace (including spaces, tabs)
                    const ok =
                      entityCodeRegex.test(inputValue) || inputValue === ''

                    setSelectedProviderSubmit([
                      ...selectedProviderSubmit.slice(
                        0,
                        selectedProviderSubmitIndex
                      ),
                      {
                        ...selectedProviderSubmit[selectedProviderSubmitIndex],
                        addOns: [
                          ...selectedProviderSubmit[
                            selectedProviderSubmitIndex
                          ].addOns.slice(0, addOnIndex),
                          {
                            ...selectedProviderSubmit[
                              selectedProviderSubmitIndex
                            ].addOns[addOnIndex],
                            code: ok ? event.currentTarget.value : ''
                          },
                          ...selectedProviderSubmit[
                            selectedProviderSubmitIndex
                          ].addOns.slice(addOnIndex + 1)
                        ]
                      },
                      ...selectedProviderSubmit.slice(
                        selectedProviderSubmitIndex + 1
                      )
                    ])
                  }}
                />
                <div className={classes.textCheckBox}>
                  <CheckboxWithLabel
                    name="Text"
                    placeholder={getTranslate('Multiplier')}
                    value={item.applyMultiplier}
                    checked={item.applyMultiplier === true ? true : undefined}
                    inputSize="small"
                    onChange={(event) => {
                      setSelectedProviderSubmit([
                        ...selectedProviderSubmit.slice(
                          0,
                          selectedProviderSubmitIndex
                        ),
                        {
                          ...selectedProviderSubmit[
                            selectedProviderSubmitIndex
                          ],
                          addOns: [
                            ...selectedProviderSubmit[
                              selectedProviderSubmitIndex
                            ].addOns.slice(0, addOnIndex),
                            {
                              ...selectedProviderSubmit[
                                selectedProviderSubmitIndex
                              ].addOns[addOnIndex],
                              applyMultiplier: event.target.checked
                            },
                            ...selectedProviderSubmit[
                              selectedProviderSubmitIndex
                            ].addOns.slice(addOnIndex + 1)
                          ]
                        },
                        ...selectedProviderSubmit.slice(
                          selectedProviderSubmitIndex + 1
                        )
                      ])
                    }}
                  />
                  <CheckboxWithLabel
                    disabled={item.type !== 'Custom'}
                    className={classes.textCheckBox}
                    name="Text"
                    placeholder={getTranslate('Per Person')}
                    value={item.perPerson}
                    checked={item.perPerson === true ? true : undefined}
                    inputSize="small"
                    onChange={(event) => {
                      setSelectedProviderSubmit([
                        ...selectedProviderSubmit.slice(
                          0,
                          selectedProviderSubmitIndex
                        ),
                        {
                          ...selectedProviderSubmit[
                            selectedProviderSubmitIndex
                          ],
                          addOns: [
                            ...selectedProviderSubmit[
                              selectedProviderSubmitIndex
                            ].addOns.slice(0, addOnIndex),
                            {
                              ...selectedProviderSubmit[
                                selectedProviderSubmitIndex
                              ].addOns[addOnIndex],
                              perPerson: event.target.checked
                            },
                            ...selectedProviderSubmit[
                              selectedProviderSubmitIndex
                            ].addOns.slice(addOnIndex + 1)
                          ]
                        },
                        ...selectedProviderSubmit.slice(
                          selectedProviderSubmitIndex + 1
                        )
                      ])
                    }}
                  />
                  <CheckboxWithLabel
                    name="Text"
                    disabled={item.type !== 'Custom'}
                    placeholder={getTranslate('Per Night')}
                    value={item.perRoomNight}
                    checked={item.perRoomNight === true ? true : undefined}
                    inputSize="small"
                    onChange={(event) => {
                      setSelectedProviderSubmit([
                        ...selectedProviderSubmit.slice(
                          0,
                          selectedProviderSubmitIndex
                        ),
                        {
                          ...selectedProviderSubmit[
                            selectedProviderSubmitIndex
                          ],
                          addOns: [
                            ...selectedProviderSubmit[
                              selectedProviderSubmitIndex
                            ].addOns.slice(0, addOnIndex),
                            {
                              ...selectedProviderSubmit[
                                selectedProviderSubmitIndex
                              ].addOns[addOnIndex],
                              perRoomNight: event.target.checked
                            },
                            ...selectedProviderSubmit[
                              selectedProviderSubmitIndex
                            ].addOns.slice(addOnIndex + 1)
                          ]
                        },
                        ...selectedProviderSubmit.slice(
                          selectedProviderSubmitIndex + 1
                        )
                      ])
                    }}
                  />
                  <div className={classes.mainButtonBase}>
                    <ButtonBase
                      onClick={() => {
                        setSelectedProviderSubmit([
                          ...selectedProviderSubmit.slice(
                            0,
                            selectedProviderSubmitIndex
                          ),
                          {
                            ...selectedProviderSubmit[
                              selectedProviderSubmitIndex
                            ],
                            addOns: [
                              ...selectedProviderSubmit[
                                selectedProviderSubmitIndex
                              ].addOns,
                              {
                                code: '',
                                name: '',
                                applyMultiplier: false,
                                perPerson: false,
                                perRoomNight: false,
                                type: 'Custom',
                                nameTranslatedList: [
                                  {
                                    label: 'Iran, Islamic Republic of',
                                    nativeLabel: 'فارسی',
                                    value: ''
                                  }
                                ],
                                notDisabled: true
                              }
                            ]
                          },
                          ...selectedProviderSubmit.slice(
                            selectedProviderSubmitIndex + 1
                          )
                        ])
                      }}
                      disabled={
                        !item.type ||
                        !item.name ||
                        !item.nameTranslatedList[0].value ||
                        !item.code
                      }>
                      {!item.type ||
                      !item.name ||
                      !item.nameTranslatedList[0].value ||
                      !item.code ? (
                        <AddCircleOutlineIcon
                          className={[
                            classes.addIconDisabled,
                            selectedProviderSubmit[selectedProviderSubmitIndex]
                              .addOns.length !==
                              addOnIndex + 1 && classes.addIconHidden
                          ].join(' ')}
                        />
                      ) : (
                        <AddCircleOutlineIcon
                          className={[
                            classes.addIcon,
                            selectedProviderSubmit[selectedProviderSubmitIndex]
                              .addOns.length !==
                              addOnIndex + 1 && classes.addIconHidden
                          ].join(' ')}
                        />
                      )}
                    </ButtonBase>
                    {addOnIndex > fixedAddonCount && (
                      <ButtonBase
                        onClick={() => {
                          setSelectedProviderSubmit([
                            ...selectedProviderSubmit.slice(
                              0,
                              selectedProviderSubmitIndex
                            ),
                            {
                              ...selectedProviderSubmit[
                                selectedProviderSubmitIndex
                              ],
                              addOns: [
                                ...selectedProviderSubmit[
                                  selectedProviderSubmitIndex
                                ].addOns.slice(0, addOnIndex),
                                ...selectedProviderSubmit[
                                  selectedProviderSubmitIndex
                                ].addOns.slice(addOnIndex + 1)
                              ]
                            },
                            ...selectedProviderSubmit.slice(
                              selectedProviderSubmitIndex + 1
                            )
                          ])
                        }}>
                        <DeleteIcon className={classes.addIconDelete} />
                      </ButtonBase>
                    )}
                  </div>
                </div>
                {isSmallScreen &&
                  addOnIndex !==
                    selectedProviderSubmit[selectedProviderSubmitIndex].addOns
                      .length -
                      1 && (
                    <div className={classes.lineSection}>
                      <div className={classes.lineSectionContainer} />
                    </div>
                  )}
              </div>
            )
          )}
        </>
      )}
    </div>
  )
}
